import { getAuthInstance } from '@fusion/auth-v3'
import { FusionStores } from '@fusion/saas-components-v3'
import { UnitOfMeasure } from '@fusion/units'
import type { BlueSkySetting, MovedToAnotherDeviceMessage, UserSetting } from '@/types/user'

export const addUserSetting = (settingObj: BlueSkySetting): Pick<UserSetting, 'bluesky'> => {
  return { bluesky: settingObj }
}

const getUnitFromUserProfileSettings = (unit: string): UnitOfMeasure => {
  const auth = getAuthInstance()
  const store = FusionStores.userProfile(auth)
  return store.settings[unit as keyof typeof store.settings]
}

export const getPMSelectedUnit = (): UnitOfMeasure => {
  return getUnitFromUserProfileSettings('pmUnit') ?? UnitOfMeasure.MICROGRAMS_PER_CUBIC_METER
}

export const getTemperatureSelectedUnit = (): UnitOfMeasure => {
  return getUnitFromUserProfileSettings('tempUnit') ?? UnitOfMeasure.DEGREES_C
}

export const getPressureSelectedUnit = (): UnitOfMeasure => {
  return getUnitFromUserProfileSettings('pressureUnit') ?? UnitOfMeasure.INCH_MERCURY
}

export const filterMovedToAnotherDeviceMessages = (
  movedToAnotherDeviceMessages: MovedToAnotherDeviceMessage[] | null,
  movedToAnotherDeviceMessage?: MovedToAnotherDeviceMessage | null
): MovedToAnotherDeviceMessage[] | null => {
  if (movedToAnotherDeviceMessages?.length && movedToAnotherDeviceMessage?.connectedDeviceSerial) {
    return movedToAnotherDeviceMessages.filter((message) => {
      return message.connectedDeviceSerial !== movedToAnotherDeviceMessage.connectedDeviceSerial
    })
  }

  return movedToAnotherDeviceMessages
}
